const products =
{
    "p1": {
        key: "p1",
        name: "name",
        image: "/images/products/p1/i1.webp",
        images: ["/images/products/p1/i1.webp",
        "/images/products/p1/i2.webp",
        "/images/products/p1/i3.webp",
        "/images/products/p1/i4.webp",
        "/images/products/p1/i5.webp",
        ],
        technique: "Tecnica 15 x 20 cm",
        price: "0.99",
        limited: 50,
        aviables: 50,
        dimension: "30 x 42 cm",
        description: "Risography is based on a very environmentally friendly cold printing process. The inks are made from soy only and contain no solvents. Each print offers a unique result, which gives each copy a unique character. Risography is based on a very environmentally friendly cold printing process. The inks are made from soy only and contain no solvents. Each print offers a unique result, which gives each copy a unique character. Risography is based on a very environmentally friendly cold printing process. The inks are made from soy only and contain no solvents. Each print offers a unique result, which gives each copy a unique character.",
        
        support: "Riso print on Munken 150g paper",
        signed: "Signed and numbered"
    },
    "p2": {
        key: "p2",
        name: "name",
        image: "/images/icons/image.png",
        images: [],
        technique: "Tecnica 15 x 20 cm",
        price: "1.99",
        limited: 50,
        aviables: 50,
        dimension: "30 x 42 cm",
        description: "descripcion de esa talla",
        support: "Riso print on Munken 150g paper",
        signed: "Signed and numbered"
    },
    "p3": {
        key: "p3",
        name: "name",
        image: "/images/icons/image.png",
        images: [],
        technique: "Tecnica 15 x 20 cm",
        price: "2.99",
        limited: 50,
        aviables: 50,
        dimension: "30 x 42 cm",
        description: "descripcion de esa talla",
        support: "Riso print on Munken 150g paper",
        signed: "Signed and numbered"
    },
    "p4": {
        key: "p4",
        name: "name",
        image: "/images/products/p1/i3.webp",
        images: ["/images/products/p1/i1.webp",
        "/images/products/p1/i2.webp",
        "/images/products/p1/i3.webp",
        "/images/products/p1/i4.webp",
        "/images/products/p1/i5.webp",
        ],
        technique: "Tecnica 15 x 20 cm",
        price: "3.99",
        limited: 50,
        aviables: 50,
        dimension: "30 x 42 cm",
        description: "Risography is based on a very environmentally friendly cold printing process. The inks are made from soy only and contain no solvents. Each print offers a unique result, which gives each copy a unique character.",
        
        support: "Riso print on Munken 150g paper",
        signed: "Signed and numbered"
    },
    "p5": {
        key: "p5",
        name: "name",
        image: "/images/products/p1/i1.webp",
        images: ["/images/products/p1/i1.webp",
        "/images/products/p1/i2.webp",
        "/images/products/p1/i3.webp",
        "/images/products/p1/i4.webp",
        "/images/products/p1/i5.webp",
        ],
        technique: "Tecnica 15 x 20 cm",
        price: "4.99",
        limited: 50,
        aviables: 50,
        dimension: "30 x 42 cm",
        description: "Risography is based on a very environmentally friendly cold printing process. The inks are made from soy only and contain no solvents. Each print offers a unique result, which gives each copy a unique character.",
        
        support: "Riso print on Munken 150g paper",
        signed: "Signed and numbered"
    },
    "p6": {
        key: "p6",
        name: "name",
        image: "/images/icons/image.png",
        images: [],
        technique: "Tecnica 15 x 20 cm",
        price: "5.99",
        limited: 50,
        aviables: 50,
        dimension: "30 x 42 cm",
        description: "descripcion de esa talla",
        support: "Riso print on Munken 150g paper",
        signed: "Signed and numbered"
    },
    "p7": {
        key: "p7",
        name: "name",
        image: "/images/icons/image.png",
        images: [],
        technique: "Tecnica 15 x 20 cm",
        price: "6.99",
        limited: 50,
        aviables: 50,
        dimension: "30 x 42 cm",
        description: "descripcion de esa talla",
        support: "Riso print on Munken 150g paper",
        signed: "Signed and numbered"
    },
    "p8": {
        key: "p8",
        name: "name",
        image: "/images/products/p1/i3.webp",
        images: ["/images/products/p1/i1.webp",
        "/images/products/p1/i2.webp",
        "/images/products/p1/i3.webp",
        "/images/products/p1/i4.webp",
        "/images/products/p1/i5.webp",
        ],
        technique: "Tecnica 15 x 20 cm",
        price: "7.99",
        limited: 50,
        aviables: 50,
        dimension: "30 x 42 cm",
        description: "Risography is based on a very environmentally friendly cold printing process. The inks are made from soy only and contain no solvents. Each print offers a unique result, which gives each copy a unique character.",
        
        support: "Riso print on Munken 150g paper",
        signed: "Signed and numbered"
    },
    "p9": {
        key: "p9",
        name: "name",
        image: "/images/products/p1/i3.webp",
        images: ["/images/products/p1/i1.webp",
        "/images/products/p1/i2.webp",
        "/images/products/p1/i3.webp",
        "/images/products/p1/i4.webp",
        "/images/products/p1/i5.webp",
        ],
        technique: "Tecnica 15 x 20 cm",
        price: "8.99",
        limited: 50,
        aviables: 50,
        dimension: "30 x 42 cm",
        description: "Risography is based on a very environmentally friendly cold printing process. The inks are made from soy only and contain no solvents. Each print offers a unique result, which gives each copy a unique character.",
        
        support: "Riso print on Munken 150g paper",
        signed: "Signed and numbered"
    },
    "p10": {
        key: "p10",
        name: "name",
        image: "/images/products/p1/i3.webp",
        images: ["/images/products/p1/i1.webp",
        "/images/products/p1/i2.webp",
        "/images/products/p1/i3.webp",
        "/images/products/p1/i4.webp",
        "/images/products/p1/i5.webp",
        ],
        technique: "Tecnica 15 x 20 cm",
        price: "9.99",
        limited: 50,
        aviables: 50,
        dimension: "30 x 42 cm",
        description: "Risography is based on a very environmentally friendly cold printing process. The inks are made from soy only and contain no solvents. Each print offers a unique result, which gives each copy a unique character.",
        
        support: "Riso print on Munken 150g paper",
        signed: "Signed and numbered"
    },
    "p11": {
        key: "p11",
        name: "name",
        image: "/images/products/p1/i3.webp",
        images: ["/images/products/p1/i1.webp",
        "/images/products/p1/i2.webp",
        "/images/products/p1/i3.webp",
        "/images/products/p1/i4.webp",
        "/images/products/p1/i5.webp",
        ],
        technique: "Tecnica 15 x 20 cm",
        price: "10.99",
        limited: 50,
        aviables: 50,
        dimension: "30 x 42 cm",
        description: "Risography is based on a very environmentally friendly cold printing process. The inks are made from soy only and contain no solvents. Each print offers a unique result, which gives each copy a unique character.",
        
        support: "Riso print on Munken 150g paper",
        signed: "Signed and numbered"
    },
};

export default products;